
function SectionSkills() {
    return (
      <div className="sectionSkills">
          <div className='sectionSkills__title'> my skills</div>  
          <div className='sectionSkills__text'>
            <p className='sectionSkills__text--parr'>Layout: HTML5, CSS3, (Flexbox and Grid), SASS. </p>

            <p className='sectionSkills__text--parr'> Responsive design, Mobile first.</p> 

            <p className='sectionSkills__text--parr'> JavaScript basics.</p>
            <p className='sectionSkills__text--parr'>Creation of SPAs with React, Components and Props. </p>
            <p className='sectionSkills__text--parr'> Git and Github for version control.</p> 
            <p className='sectionSkills__text--parr'>Slack, VS Code, Terminal, Zeplin.</p> 
        </div>     
      </div>
    );
  }
  
  export default SectionSkills;